import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { offer, offerIncludes } from '../data/content';
import { OFFER_SECTION_ID } from '../utils/scroll';
export function Offer() {
  return <section id={OFFER_SECTION_ID} className="scroll-mt-4 bg-slate-50 px-5 py-16 sm:py-20" data-id="element-154" data-mp="1mm7husnl15db">
      <div className="mx-auto max-w-3xl" data-id="element-155" data-mp="1hoxtlgbxizr2">
        <div className="overflow-hidden rounded-2xl border-2 border-gold bg-white shadow-2xl shadow-black/10" data-id="element-156" data-mp="tyldhi6j5wpe">
          <div className="bg-navy-800 px-6 py-6 text-center" data-id="element-157" data-mp="p0a396cbpk6n">
            <h2 className="font-display text-xl font-extrabold leading-snug text-white sm:text-2xl" data-id="element-158" data-mp="p1v1b5xujl99">
              Die komplette Kinderhandball-Sammlung
            </h2>
            <p className="mt-2 text-xs font-semibold uppercase tracking-[0.16em] text-gold sm:text-[13px]" data-id="element-159" data-mp="yx4xve5h70fn">
              6 PDF-Bände · 360 Seiten · 6–12 Jahre
            </p>
          </div>

          <div className="px-6 py-8 sm:px-10" data-id="element-160" data-mp="2acbiqs9dyr0m">
            <div className="text-center" data-id="element-161" data-mp="pk7fxlpl6l9g">
              <p className="font-display text-5xl font-black leading-none text-navy-800 sm:text-6xl" data-id="element-162" data-mp="pj5t6jz7kabw">
                {offer.priceLabel}
              </p>
              <p className="mt-3 text-sm font-semibold text-slate-600" data-id="element-163" data-mp="zieujxwekr8a">
                {offer.paymentLabel}
              </p>
            </div>

            <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-164" data-mp="13iyrp1gz7uuf">
              {offerIncludes.map(item => <li key={item} className="flex items-center gap-2 text-sm font-medium text-slate-700" data-id="element-165" data-mp="6v0rdi242zfq">
                  <CheckIcon className="h-4 w-4 shrink-0 text-action" aria-hidden="true" data-id="element-166" data-mp="funwoexyope2" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-167" data-mp="3k7kpionwbekb">
              <CtaButton label={offer.checkoutCtaLabel} href={offer.offerCheckoutUrl} showArrow data-id="element-168" data-mp="3k8dqf906b9uj" />
            </div>

            <p className="mt-4 text-center text-xs font-medium text-slate-500" data-id="element-169" data-mp="vefrpxtx9wyz">
              Digitale PDF-Sammlung · Kein physischer Versand.
            </p>
          </div>
        </div>
      </div>
    </section>;
}